// import { useEffect, useState } from "react";
// import apiGateWay from "../../serviceHandler";
// import { useLocation } from "react-router-dom";
// import Loader from "../Common/Loader";
// import Swal from "sweetalert2";

// const Index = () => {
//   const [checkoutId, setCheckoutId] = useState(null);
//   const [loaderItems, setLoaderItems] = useState([]);

//   const location = useLocation();

//   useEffect(() => {
//     // Fetch the checkout ID when the component mounts
//     fetchCheckoutId();
//   }, []);

//   // Load HyperPay script when checkoutId is ready
//   useEffect(() => {
//     if (checkoutId) {
//       window.wpwlOptions = { style: "card", locale: "en", paymentTarget: "_top" };
//       const script = document.createElement("script");
//       script.src = `https://test.oppwa.com/v1/paymentWidgets.js?checkoutId=${checkoutId}`;
//       script.async = true;
//       document.body.appendChild(script);

//       script.onload = () => {
//         // Script loaded → widget will render into <form>
//         handleLoader(["fetchCheckoutId"], "remove");
//       };

//       return () => {
//         document.body.removeChild(script);
//       };
//     }
//   }, [checkoutId]);

//   const handleLoader = (items, action) => {
//     switch (action) {
//       case "add":
//         setLoaderItems([
//           ...loaderItems,
//           ...items
//         ]);
//         break;
//       case "remove":
//         setLoaderItems(loaderItems.filter(item => !items.includes(item)));
//         break;
//       default:
//         break
//     }
//   };

//   const fetchCheckoutId = async () => {
//     const amount = location.state?.amount || "00";
//     try {
//       handleLoader(["fetchCheckoutId"], "add");
//       const response = await apiGateWay.get(
//         `keyconnect/simphony/InitiatePaymentCheckout?amount=${amount}`,
//       );
//       const { data } = await response?.data?.result;
//       setCheckoutId(data.id);
//     } catch (error) {
//       handleLoader(["fetchCheckoutId"], "remove");
//       Swal.fire({
//         title: "Error!",
//         text: "Failed to initiate payment. Please try again.",
//         icon: "error",
//       }).then((result) => {
//         if (result.isConfirmed) {
//           const urlData = JSON.parse(sessionStorage.getItem("urlParams"));
//           navigate('/ezmenu/' + urlData?.tableNumer + '/' + urlData?.rvc + '/' + urlData?.zone + '/' + urlData?.actualTableNumber);
//           // navigate('/' + urlData?.tableNumer + '/' + urlData?.rvc + '/' + urlData?.zone + '/' + urlData?.actualTableNumber);
//         }
//       });
//     };

//   };

//   return (
//     <div className="startWrap">
//       <div className="start-menu-wrapper">
//         {checkoutId ? (
//           <form
//             action={`${window.location.origin}/ezmenu/payment/result`}
//             // action={`${window.location.origin}/payment/result`}
//             className="paymentWidgets"
//             data-brands="MADA VISA MASTER"
//           />
//         ) : (
//           <span className="error-validation p-4 mb-4">Loading Payment page</span>
//         )}
//       </div>
//       {loaderItems.length ? <Loader /> : null}
//     </div>
//   );
// };

// export default Index;
import { useEffect, useState } from "react";
import apiGateWay from "../../serviceHandler";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../Common/Loader";
import Swal from "sweetalert2";

const Index = () => {
  const [paymentLink, setPaymentLink] = useState(null);
  const [loaderItems, setLoaderItems] = useState([]);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch the payment link when component mounts
    initiatePayment();
  }, []);

  // Redirect to payment gateway when link is ready
  useEffect(() => {
    if (paymentLink) {
      // Redirect user to the payment gateway
      window.location.href = paymentLink;
    }
  }, [paymentLink]);

  const handleLoader = (items, action) => {
    switch (action) {
      case "add":
        setLoaderItems([...loaderItems, ...items]);
        break;
      case "remove":
        setLoaderItems(loaderItems.filter(item => !items.includes(item)));
        break;
      default:
        break;
    }
  };

  const initiatePayment = async () => {
    try {
      handleLoader(["initiatePayment"], "add");

      // Get data from location state or session storage
      const urlData = JSON.parse(sessionStorage.getItem("urlParams"));
      const checkData = JSON.parse(sessionStorage.getItem("checkData"));

      const amount = location.state?.amount || 0;
      const orderId = location.state?.orderId || checkData?.orderId;

      if (!orderId) {
        throw new Error("Order ID is required for payment");
      }

      // Prepare request body
      const requestBody = {
        LocationId: parseInt(urlData?.tableNumer) || 100,
        RvcObjNum: parseInt(urlData?.rvc) || 1001, // You may need to get this from your context
        TableNumber: parseInt(urlData?.actualTableNumber) || 1,
        OrderId: orderId,
        AmountValue: parseFloat(amount),
        RedirectURLPath: "/ezmenu/payment/result/",
        CancelURLPath: `/ezmenu/${urlData?.tableNumer}/${urlData?.rvc}/${urlData?.zone}/${urlData?.actualTableNumber}`,
        // CancelURLPath: '/home/menu'
        // CancelURLPath: "/ezmenu/payment/result/",
      };

      console.log("Payment Request:", requestBody);

      // Call the new payment API
      const response = await apiGateWay.post(
        "/keyconnect/simphony/GetNIPaymentLink",
        requestBody,
      );

      if (response.status === 200) {
        // Store order reference for verification later
        // console.log("paymentAmount", response.data.result, amount);

        sessionStorage.setItem("orderReference", response.data.result.reference);
        sessionStorage.setItem("paymentAmount", amount);
        setPaymentLink(response.data.result._links.payment.href);
      } else {
        throw new Error("Failed to get payment link");
      }

      handleLoader(["initiatePayment"], "remove");
    } catch (error) {
      handleLoader(["initiatePayment"], "remove");
      console.error("Payment initiation error:", error);

      Swal.fire({
        title: "Error!",
        text: error.message || "Failed to initiate payment. Please try again.",
        icon: "error",
        confirmButtonColor: "#0f145b",
      }).then((result) => {
        if (result.isConfirmed) {
          const urlData = JSON.parse(sessionStorage.getItem("urlParams"));
          navigate(
            `/ezmenu/${urlData?.tableNumer}/${urlData?.rvc}/${urlData?.zone}/${urlData?.actualTableNumber}`
          );
        }
      });
    }
  };

  return (
    <div className="startWrap">
      <div className="start-menu-wrapper">
        <div className="text-center p-4">
          <h2 className="text-xl font-bold text-gray-700 mb-4">
            Redirecting to Payment Gateway...
          </h2>
          <p className="text-gray-600">
            Please wait while we prepare your payment.
          </p>
          <div className="mt-4">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          </div>
        </div>
      </div>
      {loaderItems.length ? <Loader /> : null}
    </div>
  );
};

export default Index;